import {Component, Input} from '@angular/core';
import {FaqGroup} from '../../data/models/faqGroup.model';

import {MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from "@angular/material/expansion";

@Component({
  selector: 'app-faqgroup',
  templateUrl: './faqgroup.component.html',
  styleUrls: ['./faqgroup.component.css'],
  imports: [
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatExpansionPanelHeader
],
  standalone: true
})
export class FaqGroupComponent {
  @Input() public faqGroup: FaqGroup;
}
